import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

interface EmptyStateProps {
  icon?: LucideIcon;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
  bordered?: boolean;
}

export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
  className = "",
  bordered = true,
}: EmptyStateProps) {
  return (
    <div
      className={`flex flex-col items-center justify-center py-16 px-6 text-center ${
        bordered ? "rounded-lg border border-border bg-card" : ""
      } ${className}`}
    >
      {Icon && (
        <div className="size-14 rounded-2xl bg-muted/50 flex items-center justify-center mb-4">
          <Icon className="size-7 d" />
        </div>
      )}
      <h3 className="text-sm font-semibold mb-1">{title}</h3>
      {description && <p className="text-sm d mb-5 max-w-sm">{description}</p>}
      {action}
    </div>
  );
}
